import { Component, OnInit } from '@angular/core';
import { AgilityRiskService } from '../../../../providers/agility-risk.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { RiskBand } from '../../../../models/risk-band';
import { ConfirmationModalComponent } from '../../../shared/modals/confirmation-modal/confirmation-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { AgilityRiskMessageService } from '../../../../providers/agility-risk-message.service';


@Component({
  selector: 'lib-add-remove-risk-bands',
  templateUrl: './add-remove-risk-bands.component.html',
  styleUrls: ['./add-remove-risk-bands.component.scss']
})
export class AddRemoveRiskBandsComponent implements OnInit {
  cols = [
    {field: 'name', header: 'Risk Band Name'},
    {field: 'color', header: 'Assigned Color'},

  ];
  colors = ['#ffffff', '#ffff00', '#ccffcc', '#99ffff', '#cccccc', '#ff9900', '#33ff33',
    '#0099ff', '#ff00ff', '#ff0000', '#33cc00', '#0000ff', '#cc00cc', '#990000', '#999900', '#006666'
  ];
  public riskBands: Array<RiskBand> = [];
  testBand = {name: 'Default Band', color: '#AAF538'};
  public formulaId: string;
  public numericValues: number[];
  confirmationDynamicDialogRef: DynamicDialogRef;

  constructor(private agilityRiskService: AgilityRiskService,
              private dynamicDialogConfig: DynamicDialogConfig,
              private dynamicDialogRef: DynamicDialogRef,
              private dialogService: DialogService,
              private messageService: AgilityRiskMessageService,
              private translateService: TranslateService) {

    this.formulaId = this.dynamicDialogConfig?.data?.formulaId || '21772'; // use just for testing, remove when using the dialog
  }


  ngOnInit(): void {
    this.agilityRiskService.getRiskFormulaBands(this.formulaId).subscribe((riskBands: Array<RiskBand>) => {
      this.riskBands = riskBands.sort((a, b) => a.numericValue - b.numericValue);
      this.numericValues = riskBands.map(band => band.numericValue);
    });
  }


  deleteRiskBand(riskBandId: string): void {
    this.confirmationDynamicDialogRef = this.dialogService.open(ConfirmationModalComponent, {
      data: {
        body: this.translateService.instant('addRemoveRiskBands.deleteRiskBandBody')
      },
      header: this.translateService.instant('addRemoveRiskBands.deleteRiskBand'),
      width: '35%'
    });

    this.confirmationDynamicDialogRef.onClose.subscribe((result: any) => {
      if (result) {
        this.agilityRiskService.deleteRiskBand(riskBandId).subscribe(
          {
            next: (response) => {
              this.refreshData();
              this.messageService.success(
                this.translateService.instant('common.success'), this.translateService.instant('addRemoveRiskBands.riskBandDeleteSuccessfully'));
            }, error: (err) => {
              this.messageService.error(
                this.translateService.instant('common.success'), this.translateService.instant('addRemoveRiskBands.riskBandDeleteUnSuccessfully'));
            }
          });
      }
    });
  }


  createRiskBand() {

    this.agilityRiskService.createRiskBand(this.formulaId, this.testBand).subscribe(
      {
        next: (response) => {
          this.refreshData();
          this.messageService.success(
            this.translateService.instant('common.success'), this.translateService.instant('addRemoveRiskBands.createRiskBandSuccessfully'));
        }, error: (err) => {
          this.messageService.error(
            this.translateService.instant('common.success'), this.translateService.instant('addRemoveRiskBands.createRiskBandUnSuccessfully'));
        }
      });
  }


  editRiskBand(riskBand: RiskBand): void {

    this.agilityRiskService.editRiskBand(riskBand).subscribe(
      {
        next: (response) => {

          this.refreshData();

          this.riskBands = this.riskBands.sort((a, b) => a.numericValue - b.numericValue);

        }, error: (err) => {

        }
      });
  }

  onRiskBandReorder(): void {
    this.riskBands.forEach((band, b) => {
      band.numericValue = this.numericValues[b];
    });
    this.savePositions();
  }


  refreshData(): void {
    this.agilityRiskService.getRiskFormulaBands(this.formulaId).subscribe((riskBands: Array<RiskBand>) => {
      this.riskBands = riskBands.sort((a, b) => a.numericValue - b.numericValue);
      this.numericValues = riskBands.map(band => band.numericValue);

    });
  }


  savePositions() {
    this.agilityRiskService.putRiskBandsPosition(this.riskBands).subscribe({
      next: (response) => {

        // TODO: is there gonna be a toast ?

      }, error: (err) => {
        // TODO: is there gonna be a toast ?

      }
    });
  }

  close(): void {
    return this.dynamicDialogRef.close();
  }

}
